import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { useHomePath } from 'src/view/hooks/useHomePath';

import { LogoIcon } from '../Icons/LogoIcon';

export const LogoLink = ({
    className,
}: React.HTMLAttributes<HTMLAnchorElement>) => {
    const home = useHomePath();
    const isMobileDevice = isMobile;

    const handleClick: React.MouseEventHandler<HTMLAnchorElement> = event => {
        if (isMobileDevice) {
            event.preventDefault();
        }
    };

    return (
        <Link
            to={home}
            className={className}
            aria-label="Homepage"
            onClick={handleClick}
            aria-disabled={isMobileDevice}
            tabIndex={isMobileDevice ? -1 : undefined}
        >
            <LogoIcon />
        </Link>
    );
};
